export default "__VITE_ASSET__BlP7BHmu__"